"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnouncementsList = void 0;

var _AnnouncementBox = require("./AnnouncementBox");

var _i18n = require("../../hooks/i18n");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const defaultProps = {
  showInlineFeedback: true,
  showTopics: true // showReadMore: true

};

const AnnouncementsList = props => {
  const {
    accessToken,
    announcements,
    language,
    showInlineFeedback,
    showTopics,
    // showReadMore,
    loudspeakerEnv,
    sessionId
  } = props;
  const listSegments = announcements.map((ann, i) => /*#__PURE__*/_react.default.createElement(_AnnouncementBox.AnnouncementBox, {
    key: i,
    accessToken: accessToken,
    language: language,
    announcement: ann,
    showInlineFeedback: showInlineFeedback,
    showTopics: showTopics // showReadMore={showReadMore}
    ,
    loudspeakerEnv: loudspeakerEnv,
    sessionId: sessionId
  }));
  const {
    tt
  } = (0, _i18n.useDoubleTTranslation)(props.language);

  if (listSegments.length === 0) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "loudspeakerNoAnnouncements"
    }, /*#__PURE__*/_react.default.createElement("span", null, tt('noUnreadAnnouncements')));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, listSegments);
};

exports.AnnouncementsList = AnnouncementsList;
AnnouncementsList.defaultProps = defaultProps;